/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".top-banner-logo-right[_ngcontent-%COMP%]   .is-app-logo[_ngcontent-%COMP%]{width:100%}.is-app-logo[_ngcontent-%COMP%]{max-width:450px;max-height:60px}.is-project-logo[_ngcontent-%COMP%]{max-width:450px;max-height:100px}.is-width-200[_ngcontent-%COMP%]{width:200px;max-height:100%}"];
export { styles as styles };
